const wijken = {
  seo: {
    title: "Werkgebied Ramen Repair | Eindhoven \u0026 Omgeving",
    description:
      "Ramen Repair Eindhoven werkt in alle wijken van Eindhoven en omliggende gemeenten. 48u service, 10 jaar garantie. Bekijk uw wijk.",
    h1: "Werkgebied : Eindhoven en omgeving",
  },
  hero: {
    subtitle:
      "Kozijn-, raam- en schuifpui reparatie in heel Groot-Eindhoven. Geen voorrijkosten binnen 15 km.",
    cta1: "Bel direct 040 798 7470",
    cta1Href: "tel:+31407987470",
    cta2: "Gratis offerte",
    cta2Href: "/contact/",
  },
  gridTitle: "Diensten per wijk",
  gridSubtitle:
    "Wij komen bij u langs in elke wijk van Eindhoven en omliggende gemeenten. Klik op uw wijk voor meer informatie.",
  cards: [
    {
      name: "Strijp",
      subtitle: "Strijp-S, Strijp-T, Philipsdorp",
      description:
        "Strijp is bekend om zijn ASML- en Philips-erfgoed. Voor kozijn- en raamreparatie in Strijp leveren wij 48u-spoedservice, ook in nieuwbouwprojecten en lofts op het Strijp-S terrein. Vaste tarieven, 10 jaar garantie.",
      href: "/wijken/strijp/",
      comingSoon: false,
    },
    {
      name: "Woensel",
      subtitle: "Woensel-Noord, Woensel-Zuid, Vaartbroek",
      description:
        "Woensel is de grootste wijk van Eindhoven met veel jaren '60-'70 woningen waar kozijnen aan vervanging toe zijn. Wij repareren PVC, hout en aluminium kozijnen. Spoedservice binnen 48u, ook voor draaikiepramen die niet meer sluiten.",
      href: "/wijken/woensel/",
      comingSoon: false,
    },
    {
      name: "Centrum",
      subtitle: "Binnenstad, Stationsgebied",
      description:
        "Het centrum van Eindhoven combineert historische panden en moderne appartementen. Wij hebben ervaring met monumentale kozijnen, schuifpuien in nieuwbouw en spoedreparaties na inbraakschade. Discrete service, vaste tarieven.",
      href: "/wijken/centrum/",
      comingSoon: false,
    },
    {
      name: "Tongelre",
      subtitle: "Lakerlopen, 't Hofke, Doornakkers",
      description:
        "In Tongelre staan veel woningen uit de jaren '50-'80 met houten en kunststof kozijnen. Wij repareren scharnieren, sluitmechanismen en vervangen glas inclusief HR++. ISDE-subsidie aanvragen wij gratis voor u mee.",
      href: "/wijken/tongelre/",
      comingSoon: false,
    },
    {
      name: "Gestel",
      subtitle: "Achtse Barrier, Oud-Gestel, Gennep",
      description:
        "In Gestel staan veel woningen uit de jaren '30 en nieuwbouw. Wij repareren kozijnen, schuifpuien en Velux-ramen in Hanevoet, Genderdal en Ooievaarsnest. Spoedservice 48u, vaste prijzen.",
      href: "/wijken/gestel/",
      comingSoon: false,
    },
    {
      name: "Stratum",
      subtitle: "Stratums Eind, Geestenberg, Joriskwartier",
      description: "Stratum is een van de oudste wijken van Eindhoven met veel jaren '50-'70 rijtjeswoningen. Wij stellen draaikiepramen af, vervangen Roto / Winkhaus / Maco beslag en repareren schuifpuien. Geen voorrijkosten, 48u-spoedservice.",
      href: "/wijken/stratum/",
      comingSoon: false,
    },
    {
      name: "Geldrop",
      subtitle: "Geldrop Centrum, Skandia, Hulst",
      description: "Geldrop-Mierlo grenst aan Eindhoven. Wij repareren alle merken kozijnen en vervangen enkel glas door HR++. ISDE-subsidie aanvragen wij gratis voor u mee. Geen voorrijkosten binnen 15 km.",
      href: "/wijken/geldrop/",
      comingSoon: false,
    },
    {
      name: "Veldhoven",
      subtitle: "Dorp, Meerveldhoven, Zonderwijk",
      description:
        "Veldhoven ligt direct tegen Eindhoven aan. Wij repareren kozijnen, schuifpuien en dakramen in Veldhoven Dorp, Meerveldhoven en Zonderwijk. Geen voorrijkosten, 48u-spoedservice.",
      href: "/wijken/veldhoven/",
      comingSoon: false,
    },
  ],
  comingSoonLabel: "Binnenkort beschikbaar",
  serviceLabel: "Diensten in {name}",
};

export default wijken;